/**
 * The two switches on the assessment artwork, in one place because design and business are the ones
 * who decide them and neither should have to read a component to find them.
 *
 * They are independent on purpose: the two animations come from different mechanisms, so wanting one
 * without the other is a real option rather than an all-or-nothing.
 *
 * Whatever these say, a reader who has asked their system for less motion gets none of it: that
 * preference overrides both, and is not negotiable in a medical product.
 */
export const TODAY_ASSESSMENT_ART_MOTION = {
  /**
   * The subtle wobble the drawing carries by itself, with nobody touching it. It is drawn into the
   * file, so switching this off does not mean asking design for another export: the drawing is held
   * on its first frame instead, which is exactly the still illustration it is built from.
   *
   * Off = the card only ever moves under the pointer, which is the "no funfair" reading of the
   * design's stated aim.
   */
  restAnimation: true,

  /**
   * What happens while the pointer stays on the card. Every one of the design system's files plays
   * its animation once and stops, so ON OVERRIDES THE FILES: it forces them to repeat.
   *
   * Off is what the drawings actually say. Either way the animation restarts on the way back in.
   */
  loopWhileHovered: false,
};
